<template>
  <header class="mmm-mobile-header">
    <span class="mmm-mobile-header__login">
      <button
        class="mmm-mobile-header-closer"
        @click="toggleMenu()"
        :aria-label="open ? 'Navigation öffnen' : 'Navigation schließen'"
      >
        <IconMenu v-if="!open" class="mmm-mobile-header-closer__menu" />
        <IconClose v-if="open" class="mmm-mobile-header-closer__cross" />
      </button>
    </span>
    <span class="mmm-mobile-header__logo">
      <a :href="rootPath" class="mmm-mobile-header__logo__link" aria-label="Startseite">
        <Logo class="mmm-header-mobile-logo" />
      </a>
    </span>
  </header>
</template>

<script lang="ts" setup>
import Logo from '../shared/LogoHausbank.ce.vue';

import IconClose from '~icons/mmm/close';
import IconMenu from '~icons/mmm/menu';

defineProps<{
  rootPath: string;
  open: boolean;
}>();

const emits = defineEmits(['toggle', 'toggleLogin']);

function toggleMenu() {
  emits('toggle');
}
</script>

<style lang="scss" scoped>
@use '../../../common/styles/utils/utils';

.mmm-mobile-header {
  position: fixed;
  height: var(--header-mobile-height);
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: var(--color-background-background);
  border-bottom: 2px solid var(--mobile-border-color);

  &__menu,
  &__login {
    flex: 0 0 var(--header-mobile-height);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__logo {
    flex: 1 1 auto;
    padding: utils.px-to-rem(16);
    justify-content: flex-start;
    align-items: center;
    display: flex;
    transform: translateY(2px);

    &__link {
      flex: 0 0 auto;
      height: 100%;
      color: var(--color-primary-lighter);

      &:active,
      &:visited {
        color: var(--color-primary-lighter);
      }
    }
  }
}

.mmm-mobile-header-closer {
  flex: 0 0 var(--header-mobile-height);
  display: flex;
  justify-content: center;
  align-items: center;
  height: var(--header-mobile-height);
  width: var(--header-mobile-height);
  background-color: transparent;
  border: none;
  position: relative;
  z-index: 1;

  &__menu,
  &__cross {
    height: utils.px-to-rem(34);
    width: utils.px-to-rem(34);
    color: var(--mobile-menu-color);
  }

  &::before,
  &::after {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    content: '';
    background-color: var(--color-primary-500-contrast);
    display: block;
    border-radius: 4px;
    height: 37px;
    width: 37px;
    z-index: -1;
  }
}

.mmm-mobile-header-overlay {
  height: calc(100svh - var(--header-mobile-height));
  box-sizing: border-box;
  width: 100vw;
  max-width: 100vw;
  position: fixed;
  left: 0;
  padding: 0;
  right: auto;
  top: var(--header-mobile-height);
  border: none;
  z-index: 1;
  background-color: var(--backdrop-color);
  padding: 0;
}

.mmm-header-mobile-logo {
  height: 100%;
  width: auto;
  color: var(--color-primary-lighter);
}
</style>
